import axios from 'axios';
import {
  defaultRequestResolve,
  defaultRequestReject,
  defaultResponseResolve,
  defaultResponseReject,
} from './interceptors';

const baseReq = axios.create({
  timeout: 8000
});

baseReq
  .interceptors
  .request
  .use(defaultRequestResolve, defaultRequestReject);

baseReq
  .interceptors
  .response
  .use(defaultResponseResolve, defaultResponseReject);

/**
 * 工作台 获取服务列表
 */
function getServices() {
  return baseReq.get('/platform/api/v1/console');
}

/**
 * 获取店铺列表
 * @param {Object} params
 */
function getShopList(siteId, params) {
  return baseReq.get(`/shop/api/sites/${siteId}/shops`, { params }).then(data => {
    return { items: data }
  })
}

/**
 * 获取店铺列表总数
 * @param {*} siteId 
 * @param {*} params 
 */
function getShopsCount(siteId, params) {
  return baseReq.get(`/shop/api/sites/${siteId}/shops-count`, { params }).then(data => {
    return data + 1;
  })
}

/**
 * 获取站点列表
 *  @param {*} params 
 */
function getSiteList(params) {
  return baseReq.get('/site/ajax-list-site-v1', { params }).then(data => {
    return { items: data.list, total: data.total }
  })
}

function getSpecialSiteId() {
  return baseReq.get('/platform/kz_ssl/privateDomain/openSite').then(data => data)
}

/**
 * 获取公众号列表
 * @param {*} params
 */
function getOffAccountList(params) {
  const _page = params.page - 1;
  const _params = { ...params, page: _page};
  return baseReq.get('/kzweixin/public/v1/accounts', { params: _params }).then(data=> {
    return { items: data.accounts, total: data.total}
  })
}

const APIs = {
  getServices,
  getShopList,
  getShopsCount,
  getSiteList,
  getOffAccountList,
  getSpecialSiteId,
}

export default APIs;